export default function CallToAction() {
  const scrollToReserva = () => {
    const element = document.getElementById('reserva');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative py-32 px-6 lg:px-12 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e6dfd5bfb1417d9667cc48db76584376.jpg"
          alt="Em Breve - Reserve Agora"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <p className="text-amber-400 text-sm tracking-[0.3em] uppercase mb-6 font-medium" style={{ fontFamily: 'Inter, sans-serif' }}>
          Oportunidade Exclusiva
        </p>
        <h2 className="text-5xl lg:text-6xl font-normal text-white mb-8" style={{ fontFamily: 'DM Serif Display, serif' }}>
          Não Perca Esta Chance Única
        </h2>
        <p className="text-gray-200 text-base leading-relaxed mb-12 max-w-2xl mx-auto" style={{ fontFamily: 'Inter, sans-serif' }}>
          As melhores unidades e condições são para quem age primeiro. Reserve agora sua unidade e garanta seu lugar neste empreendimento exclusivo.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button 
            onClick={scrollToReserva}
            className="bg-amber-600 text-white px-10 py-4 rounded-lg text-sm tracking-wide font-semibold hover:bg-amber-700 transition-all duration-300 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            RESERVE SUA UNIDADE
          </button>
          <a 
            href="https://wa.me/5527999999999?text=Olá! Gostaria de mais informações sobre o empreendimento Em Breve."
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-gray-900 px-10 py-4 rounded-lg text-sm tracking-wide font-semibold hover:bg-gray-100 transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            <i className="ri-whatsapp-line text-lg"></i>
            FALE CONOSCO
          </a>
        </div>
      </div>
    </section>
  );
}
